import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { introducerService } from '../services/api';
import '../styles/CreateIntroducer.css';

export default function CreateIntroducer() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({
    name: '',
    type: 'individual',
    company_name: '',
    address: '',
    fee_type: 'fixed',
    fixed_fee: '',
    fee_percentage: '',
    company_allocation: 50,
    manager_allocation: 10,
    sales_rep_allocation: 40,
    contact_email: '',
    contact_phone: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: name.includes('allocation') || name.includes('fee') ? parseFloat(value) || '' : value });
  };

  const validateAllocations = () => {
    const total = (parseFloat(form.company_allocation) || 0) + (parseFloat(form.manager_allocation) || 0) + (parseFloat(form.sales_rep_allocation) || 0);
    if (Math.abs(total - 100) > 0.01) {
      setError(`Allocations must equal 100%. Current: ${total}%`);
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!validateAllocations()) return;
    setLoading(true);
    try {
      await introducerService.create(form);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create introducer');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-introducer">
      <header className="header">
        <h1>Create Introducer</h1>
        <button onClick={() => navigate('/dashboard')} className="back-btn">Back to Dashboard</button>
      </header>

      <main className="main">
        <form onSubmit={handleSubmit} className="form">
          <section className="form-section">
            <h2>Basic Information</h2>
            <div className="form-group">
              <label>Name *</label>
              <input type="text" name="name" value={form.name} onChange={handleChange} placeholder="e.g., ABC Solicitors" required />
            </div>
            <div className="form-group">
              <label>Individual or Company? *</label>
              <select name="type" value={form.type} onChange={handleChange} required>
                <option value="individual">Individual</option>
                <option value="company">Company</option>
              </select>
            </div>
            {form.type === 'company' && (
              <>
                <div className="form-group">
                  <label>Company Name *</label>
                  <input type="text" name="company_name" value={form.company_name} onChange={handleChange} placeholder="e.g., ABC Solicitors Ltd" required />
                </div>
                <div className="form-group">
                  <label>Company Address</label>
                  <input type="text" name="address" value={form.address} onChange={handleChange} placeholder="Business or correspondence address" />
                </div>
              </>
            )}
            <div className="form-group">
              <label>Contact Email *</label>
              <input type="email" name="contact_email" value={form.contact_email} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Contact Phone *</label>
              <input type="tel" name="contact_phone" value={form.contact_phone} onChange={handleChange} required />
            </div>
          </section>

          <section className="form-section">
            <h2>Fee Configuration</h2>
            <div className="form-group">
              <label>Fee Type *</label>
              <select name="fee_type" value={form.fee_type} onChange={handleChange} required>
                <option value="fixed">Fixed Amount (£)</option>
                <option value="percentage">Percentage (%)</option>
              </select>
            </div>
            {form.fee_type === 'fixed' && (
              <div className="form-group">
                <label>Fixed Fee (£) *</label>
                <input type="number" name="fixed_fee" value={form.fixed_fee} onChange={handleChange} required />
              </div>
            )}
            {form.fee_type === 'percentage' && (
              <div className="form-group">
                <label>Fee Percentage (%) *</label>
                <input type="number" name="fee_percentage" value={form.fee_percentage} onChange={handleChange} required />
              </div>
            )}
          </section>

          <section className="form-section">
            <h2>Commission Split</h2>
            <div className="split-grid">
              <div className="form-group">
                <label>Company % *</label>
                <input type="number" name="company_allocation" value={form.company_allocation} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>Manager % *</label>
                <input type="number" name="manager_allocation" value={form.manager_allocation} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>Sales Rep % *</label>
                <input type="number" name="sales_rep_allocation" value={form.sales_rep_allocation} onChange={handleChange} required />
              </div>
            </div>
          </section>

          {error && <div className="error-message">{error}</div>}
          <div className="form-actions">
            <button type="submit" disabled={loading} className="submit-btn">{loading ? 'Creating...' : 'Create Introducer'}</button>
            <button type="button" onClick={() => navigate('/dashboard')} className="cancel-btn">Cancel</button>
          </div>
        </form>
      </main>
    </div>
  );
}
